export default __webpack_public_path__ + "static/media/five_icon21.210de494.png";